import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Logger } from '@se/se.ui.html5';

import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService {
    constructor(
        private authenticationService: AuthenticationService,
        private logger: Logger,
        private router: Router
    ) {}

    canActivate(snapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
        if (this.authenticationService.isAuthenticated) {
            return true;
        }

        if (snapshot.data.hasWebLogin) {
            return this.guardWebLoginAuthentication(snapshot, state);
        }

        return this.guardAuthentication();
    }

    /**
     * Pagina standard.
     * Se l'utente non è autenticato redirigi alla pagina di login.
     */
    private guardAuthentication() {
        return this.router.navigate(['login']);
    }

    /**
     * Pagina con login via token.
     * Se l'utente non è autenticato prova a fare il login con token, se non riesce controlla se è necessario chiudere la finestra
     *   (per es. in caso di iframe a schermo intero).
     * In caso l'utente sia già loggato, rimuovi il token dalla url.
     */
    private async guardWebLoginAuthentication(snapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const queryParams = snapshot.queryParams;

        if (!queryParams.token) {
            return this.authenticationService.isAuthenticated;
        }

        return this.authenticationService.estensaWebLogin(queryParams.token).catch(err => {
            if (snapshot.data.onAuthError === 'close') {
                window.close();
            }

            this.logger.error(err);

            return false;
        });
    }
}
